/**
* 通用的帮助类
* vux中有很多的帮助类，也可以直接使用
* https://vux.li/#/zh-CN/README?id=%E5%B7%A5%E5%85%B7%E5%BA%93
*
* @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
* @link
* @create 2018-03-15
*/

import conf from "./../../config/base.js";
import regexpValid from "./regexp.js";

import dateFormat from 'vux/src/tools/date/format.js'


var chars = [
'0',
'1',
'2',
'3',
'4',
'5',
'6',
'7',
'8',
'9',
'A',
'B',
'C',
'D',
'E',
'F',
'G',
'H',
'I',
'J',
'K',
'L',
'M',
'N',
'O',
'P',
'Q',
'R',
'S',
'T',
'U',
'V',
'W',
'X',
'Y',
'Z'
];
export function generateMixed(n) {
var res = '';
for (var i = 0; i < n; i++) {
var id = Math.ceil(Math.random() * 35);
res += chars[id]
}
return res
}


/**
* 生成UUID
*
* @returns
*/
export function generateUuid() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
var r = Math.random() * 16 | 0,
v = c === 'x' ? r : (r & 0x3 | 0x8);
return v.toString(16);

});
}



/**
* 设置token
* @param {any} token
*/
export function setToken(token) {
if (____isAppH5Browser()) {
localStorage.setItem('invoiceAssistantMobileAuthInfoH5', token);
}
if (____isAlipayBrowser()) {
localStorage.setItem('invoiceAssistantMobileAuthInfoAlipay', token);
}
if (____isWechatBrowser()) {
localStorage.setItem('invoiceAssistantMobileAuthInfoWechat', token);
}

}
/**
* 获取存储在 sessionStorage 中的token
* @returns
*/
export function getToken() {

var token = '';
if (____isAppH5Browser()) {
token = localStorage.getItem('invoiceAssistantMobileAuthInfoH5');
}
if (____isAlipayBrowser()) {
token = localStorage.getItem('invoiceAssistantMobileAuthInfoAlipay');
}
if (____isWechatBrowser()) {
token = localStorage.getItem('invoiceAssistantMobileAuthInfoWechat');
}
if (token === 'undefined' || token === 'null') {
token = null;
}
return token;
}
/**
* 删除存储在 sessionStorage中的token
* @returns
*/
export function clearToken() {
if (____isAppH5Browser()) {
localStorage.removeItem('invoiceAssistantMobileAuthInfoH5');
}
if (____isAlipayBrowser()) {
localStorage.removeItem('invoiceAssistantMobileAuthInfoAlipay');
}
if (____isWechatBrowser()) {
localStorage.removeItem('invoiceAssistantMobileAuthInfoWechat');
}
}
/**
* 设置resouce
* @param {any} token
*/
export function setResouce(resouce) {
if (____isAppH5Browser()) {
localStorage.setItem('invoiceAssistantMobileResouceH5', resouce);
}
if (____isAlipayBrowser()) {
localStorage.setItem('invoiceAssistantMobileResouceAlipay', resouce);
}
if (____isWechatBrowser()) {
localStorage.setItem('invoiceAssistantMobileResouceWechat', resouce);
}

}
/**
* 获取resouce
* @param {any} token
*/
export function getResouce() {
var resouce = 'SUGUO-H5';
if (____isAppH5Browser()) {
resouce = localStorage.getItem('invoiceAssistantMobileResouceH5');
}
if (____isAlipayBrowser()) {
resouce = localStorage.getItem('invoiceAssistantMobileResouceAlipay');
}
if (____isWechatBrowser()) {
resouce = localStorage.getItem('invoiceAssistantMobileResouceWechat');
}
if (resouce === null || resouce  === '' || resouce  === 'undefined' || resouce === 'null') {
resouce = "SUGUO-H5";
}
return resouce;

}
/**
* 设置用户自定义设置
* @param {any} token
*/
export function setUserSetting(setting) {


if (____isAppH5Browser()) {
localStorage.setItem('invoiceAssistantMobileUserSettingH5', setting);
}
if (____isAlipayBrowser()) {
localStorage.setItem('invoiceAssistantMobileUserSettingAlipay', setting);
}
if (____isWechatBrowser()) {
localStorage.setItem('invoiceAssistantMobileUserSettingWechat', setting);
}


}
/**
* 获取存储在 localStorage中的 用户自定义设置
* @returns
*/
export function getUserSetting() {


var setting = '';
if (____isAppH5Browser()) {
setting = localStorage.getItem('invoiceAssistantMobileUserSettingH5');
}
if (____isAlipayBrowser()) {
setting = localStorage.getItem('invoiceAssistantMobileUserSettingAlipay');
}
if (____isWechatBrowser()) {
setting = localStorage.getItem('invoiceAssistantMobileUserSettingWechat');
}
return setting;
}
/**
* 删除存储在 localStorage中的 用户自定义设置
* @returns
*/
export function clearUserSetting() {

if (____isAppH5Browser()) {
localStorage.removeItem('invoiceAssistantMobileUserSettingH5');
}
if (____isAlipayBrowser()) {
localStorage.removeItem('invoiceAssistantMobileUserSettingAlipay');
}
if (____isWechatBrowser()) {
localStorage.removeItem('invoiceAssistantMobileUserSettingWechat');
}

}


export function clog($msg, $type) {
var tm = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss')

var type = $type || 'info';
var str = tm + ' [' + type + ']:' + (typeof ($msg) === "object" ? JSON.stringify($msg) : $msg);
if (conf.debug) {
if ($type === 'ERR') {
console.log('%c' + str, 'color:#ff00ff;');
} else {
console.log('%c' + str, 'color:#0080ff;');
}
}
return str;
}

/**
* 将格式如 20180402115522  时间字符串 格式化
* @param {*} dateStr   //YYYY-MM-DD HH:mm:ss
*/
export function formatDateTime2(dateStr, fmt) {
if (dateStr == null || dateStr.length === 0) {
return '';
}

var tempDate = '' + dateStr[0] + dateStr[1] + dateStr[2] + dateStr[3] + '/' 
+
dateStr[4] + dateStr[5] + '/' 
+
dateStr[6] + dateStr[7] + ' ' 
+
dateStr[8] + dateStr[9] + ':' +
dateStr[10] + dateStr[11] + ':' +
dateStr[12] + dateStr[13] + '';
var tm = dateFormat(new Date(tempDate), fmt || 'YYYY-MM-DD HH:mm:ss');
return tm;

}
/**
* 将格式如 20180402  日期字符串 格式化
* @param {*} dateStr
* @param {*} fmt   //YYYY-MM-DD HH:mm:ss
*/
export function formatDateTime3(dateStr, fmt) {
if (dateStr == null || dateStr.length === 0) {
return '';
}

var tempDate = '' + dateStr[0] + dateStr[1] + dateStr[2] + dateStr[3] + '/' 
+
dateStr[4] + dateStr[5] + '/' 
+
dateStr[6] + dateStr[7] + ' ' 
+
'00:00:00';
var tm = dateFormat(new Date(tempDate), fmt || 'YYYY-MM-DD HH:mm:ss');
return tm;

}
/**
* 将金额保留小数两位再转换为千分位
* @param {*} num
*/
export function thousandBitSeparator(num) {
if(isNaN(parseFloat(num))){
return "";
}
num = parseFloat(num).toFixed(2);
return num && (num
.toString().indexOf('.') !== -1 ? num.toString().replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
return $1 + ",";
}) : num.toString().replace(/(\d)(?=(\d{3}))/g, function($0, $1) {
return $1 + ",";
}));
}



/*对象深拷贝
*create by yk 2016/5/19
*/


var util = (function () {
var class2type = {};
["Null", "Undefined", "Number", "Boolean", "String", "Object", "Function", "Array", "RegExp", "Date"].forEach(function (item) {
class2type["[object " + item + "]"] = item.toLowerCase();
})

function isType(obj, type) {
return getType(obj) === type;
}

function getType(obj) {
return class2type[Object.prototype.toString.call(obj)] || "object";
}
return {
isType: isType,
getType: getType
}
})();
/**
* 对象深copy  浅copy
*/
export function copyObject(obj, deep) {

if (obj === null || typeof obj !== "object") {
return obj;
}　　　　 //定义需要的局部变脸，根据obj的类型来调整target的类型
var i, target = util.isType(obj, "array") ? [] : {},
value, valueType;
for (i in obj) {
value = obj[i];
valueType = util.getType(value);　　　　　　　 
if (deep && (valueType === "array" || valueType === "object")) {
target[i] = copyObject(value);
} else {
target[i] = value;
}
}
return target;
}

/**
* 获取客户端浏览器语言环境
*/
export function getBrowserLanguage() {
return (navigator.language || navigator.browserLanguage); 
}


/**
* 解析发票二维码内容
*
* 增值税普通发票 01,04,3300164320,30856012,318.10,20180508,11475938679360667598,865b,
* 增值税专用发票 01,01,3100171130,09725707,3773.58,20170630,,EAB,
* 增值税电子普通发票 01,10,031001700311,50756616,1203.77,20180404,11475938679360667598,5EFF,
* 通行费增值税电子普通发票  01,10,011001700112,14280029,4.61,20180111,01916804770189053905,4F16,
* 增值税普通发票(卷票) 01,11,3100173320,30856012,,,,865b,
* 机动车销售统一发票  01,03,150001722060,00871843,118987.18,20180322,,CDA8,
*/
export function getVATQrcodeContent(val) {

var nowYear = new Date().getFullYear();

if (val) {
try {
var arrVal = val.split(",");
if (arrVal.length <7) {
return null;
}

if (arrVal[0] !== "01") {
return null;
}

if (!(/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2]))) {
return null;
}


if (/^\d{10}$/.test(arrVal[2])) {



var one2four = parseInt(arrVal[2][0] + '' + arrVal[2][1] + arrVal[2][2] + arrVal[2][3]);

if (one2four < 1100 ||
(one2four > 1599 && one2four < 2100) ||
(one2four > 2399 && one2four < 3100) ||

(one2four > 3799 && one2four < 4100) ||
(one2four > 4699 && one2four < 5000) ||

(one2four > 5499 && one2four < 6100) ||
(one2four > 6599)
) {
return null;
}

var fivesix = parseInt('20' + arrVal[2][4] + '' + arrVal[2][5]);

if (!(fivesix >= 2001 && fivesix <= nowYear)) {
return null;
}




if ([1, 2, 3, 5, 6, 7, '1', '2', '3', '5', '6', '7'].indexOf(arrVal[2][7]) === -1) {
return null;
}
}



if (/^\d{12}$/.test(arrVal[2])) {
/*
第1位数字限制：0，1当第1位为0且第11-12位为11时为增值税电子普通发票；
当第1位为0且第11-12位为04或05增值税普通发票（折叠票）（04-两联；05-五联）;
当第1位为0且第11-12位为06或07时为增值税普通发票（卷票）；
当第1位为1且第8位为2时为机动车销售统一发票.
当第11-12为17二手车销售统一发票
当第11-12为26通栏式发票
当第1位为0且第11-12为12通行费电子普通发票
*/
if ([0, 1, '0', '1'].indexOf(arrVal[2][0]) === -1) {
return null;
}



var two2five = parseInt(arrVal[2][1] + '' + arrVal[2][2] + arrVal[2][3] + arrVal[2][4]);
if (two2five < 1100 ||
(two2five > 1599 && two2five < 2100) ||
(two2five > 2399 && two2five < 3100) ||

(two2five > 3799 && two2five < 4100) ||
(two2five > 4699 && two2five < 5000) ||

(two2five > 5499 && two2five < 6100) ||
(two2five > 6599)
) {
return null;
}


var sixsevern = parseInt('20' + arrVal[2][5] + '' + arrVal[2][6]);
if (!(sixsevern >= 2001 && sixsevern <= nowYear)) {
return null;
}
}


if (!(/^\d{8}$/.test(arrVal[3]))) {
return null;
}




if (arrVal[0] === "01" &&
arrVal[1] === "01" &&

/^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) &&

/^\d{8}$/.test(arrVal[5]) &&
regexpValid.toDateFromString(arrVal[5]) != null 

) {

return {
documentType: "10001001",
code: arrVal[2],
no: arrVal[3],
date: arrVal[5],
totalAmount: arrVal[4],
checkCode: ""
}
}


if (

arrVal[0] === "01" &&
arrVal[1] === "11" &&

(/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) &&

/^\d{8}$/.test(arrVal[3]) &&

arrVal[4] === "" &&

arrVal[5] === "" &&

arrVal[6] === "" &&

arrVal[7] !== ""
) {
return {
documentType: "40001001",
code: arrVal[2],
no: arrVal[3],
date: arrVal[5],
totalAmount: arrVal[4],
checkCode: arrVal[6]
};
}





if (arrVal[0] === "01" &&
arrVal[1] === "03" &&

(/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) &&

/^\d{8}$/.test(arrVal[3]) &&

/^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) &&

/^\d{8}$/.test(arrVal[5]) &&
regexpValid.toDateFromString(arrVal[5]) != null
) {
return {
documentType: "50001001",
code: arrVal[2],
no: arrVal[3],
date: arrVal[5],
totalAmount: arrVal[4],
checkCode: arrVal[6]
};
}




if (arrVal[0] === "01" &&
arrVal[1] === "10" &&

(/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) &&

/^\d{8}$/.test(arrVal[3]) &&

/^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) &&

/^\d{8}$/.test(arrVal[5]) &&
regexpValid.toDateFromString(arrVal[5]) != null &&

/^\d{20}$/.test(arrVal[6])
) {
return {
documentType: "30001001",
code: arrVal[2],
no: arrVal[3],
date: arrVal[5],
totalAmount: arrVal[4],
checkCode: arrVal[6]
};
}




if (arrVal[0] === "01" &&
arrVal[1] === "04" &&

(/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) &&

/^\d{8}$/.test(arrVal[3]) &&

/^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) &&

/^\d{8}$/.test(arrVal[5]) &&
regexpValid.toDateFromString(arrVal[5]) != null &&

/^\d{20}$/.test(arrVal[6])
) {
return {
documentType: "20001001",
code: arrVal[2],
no: arrVal[3],
date: arrVal[5],
totalAmount: arrVal[4],
checkCode: arrVal[6]
};
}
return null;
} catch (error) {
return null;
}
} else {
return null;
}
}

/**
* 获取链接参数，参数可能分布在? #之间前后...
*/
export function getUrlKey(url, name) {
return (
decodeURIComponent(
(new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
url
) || [, ""])[1].replace(/\+/g, "%20")
) || null
);
}
/**
* 获取cookie
*/
export function getCookie(c_name) {
if (document.cookie.length > 0) {
let c_start ="";
let c_end ="";
c_start = document.cookie.indexOf(c_name + "=");
if (c_start !== -1) {
c_start = c_start + c_name.length + 1;
c_end = document.cookie.indexOf(";", c_start);
if (c_end === -1) c_end = document.cookie.length;
return unescape(document.cookie.substring(c_start, c_end));
}
}
return "";
}



// WEBPACK FOOTER //
// ./src/common/js/common.js